<template>
  <GenericStep v-bind="$attrs">
    <PartyDetailsCard
      :item="peParty"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual, pick } from 'lodash'
import { mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import PartyDetailsCard from '@/components/Party/PartyEdit/SectionCards/PersonalDataCards/PartyDetailsCard.vue'

export default {
  name: 'PartyDetailsStep',

  components: {
    GenericStep,
    PartyDetailsCard,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return pick(
        this.peParty, [
          'first_name',
          'middle_name',
          'last_name',
          'dob',
          'city_of_birth',
          'state_of_birth',
          'birth_country_id',
          'gender_id',
          'deceased',
        ]
      )
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },
}
</script>
